export const importFromCsv = {
  importSuccessfully: 'Import employees successfully!',
  importFailed: 'Import employees failed!',
}
